<template>
<!-- main -->
<main id="container">	

    <!-- 메인비주얼 -->
    <section id="visual" class="section">
        <div class="inner">
            <div class="title_area">
                <u>
                    CEO클리닉 T_앨리<br>
                    <b>[Tax Alliance]</b>
                </u>
                <p>
                    <span>
                        변화를 두려워 하지 않고 세무컨설팅에<br>
                        새로운 패러다임을 여는 패스파인더<br>
                        CEO클리닉 T_앨리가 이제 <b>세무사 여러분과 함께</b> 합니다.
                    </span>
                    <span>
                        법인컨설팅의 명가<br>
                        피플라이프의 또 하나의 브랜드<br>
                        전문가를 위한 통합 컨설팅 전문가 그룹 <b>CEO클리닉 Tax Alliance</b>
                    </span>
                </p>
                <nav></nav>
            </div>
            <div class="img_area">
                <ul>
                    <li>
                        <img :src="imgPath+'visual_img_01.jpg'" alt="">
                    </li>
                    <li>
                        <img :src="imgPath+'visual_img_02.jpg'" alt="">
                    </li>
                    <li>
                        <img :src="imgPath+'visual_img_03.jpg'" alt="">
                    </li>
                    <li>
                        <img :src="imgPath+'visual_img_04.jpg'" alt="">
                    </li>
                </ul>
            </div>
        </div>
    </section>
    <!-- //메인비주얼 -->

	<!-- 바로가기 -->
	<div id="sticky_wrap">
		<div id="nav">
			<div class="inner">			
				<div class="contents_area">
					<div class="menu">
						<button type="button" data-target="#about">
							<img :src="imgPath+'header_ico.png'" alt="">
							<span>_앨리 소개</span>
						</button>
						<button type="button" data-target="#education">
							<img :src="imgPath+'header_ico.png'" alt="">
							<span>_앨리 교육지원</span>
						</button>
						<button type="button" data-target="#favor">
							<img :src="imgPath+'header_ico.png'" alt="">
							<span>_앨리 혜택</span>
						</button>				
						<button type="button" class="btn_consulting" data-target="#consulting">
							<img :src="imgPath+'header_ico.png'" alt="">
							<span>_앨리 문의하기</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- //바로가기 -->

    <!-- T_앨리란 -->
    <section id="about" class="section">
        <div class="inner">
            <div class="title_area anim">
                <em>세무사와 함께 성장하는 새로운 비즈니스 동반자</em>
                <u>
                    T_앨리<br>
                    [Tax Alliance] 란?
                </u>
            </div>
            <div class="contents_area anim">
                <nav>
                    <button type="button" class="prev"></button>
                    <button type="button" class="next"></button>
                </nav>
                <ul>
                    <li>
                        T_앨리[Tax Alliance]는<br>
                        무슨 의미인가요?
                    </li>
                    <li>
                        고객을 소개해주고<br>
                        수수료 혜택을 받는 역할인가요?
                    </li>
                    <li>
                        피플라이프 T_앨리는 타보험 회사와<br>
                        차별된다는 의미인가요?
                    </li>
                    <li>
                        세무사 자격과 열정만 있으면 되나요?
                    </li>
                    <li>
                        전업으로 경영컨설팅을 해야 하나요?
                    </li>
					<li>
							T_앨리[T_Alliance]는 성장을 통해 <br>어떤 세무사가 되는 것이 비전인가요?
						</li>
                </ul>
                <div class="answer">
                    <p>
                        T_앨리는 Tax와 Alliance 합성어의 T Alliance의<br>
                        줄임말 T Ally를 고객께서 보다 친근하게<br>
                        부를 수 있도록 쉽게 표현하였습니다.
                    </p>
                    <p>
                        가능합니다.<br>
                        다만, 단순한 수수료 혜택은<br>
                        다른 보험대리점도 가능합니다.
                    </p>
                    <p>
                        네 다릅니다.<br>
                        피플라이프 T_앨리는 세무사로서 고객을 위해<br>
                        더욱 성장하며, 좀 더 안전하고 확장된<br>
                        서비스를 제공 할 열정을 가지신 분들을<br>
                        모시고 있습니다.
                    </p>
                    <p>
                        그렇지 않습니다.<br>
                        안정적인 기반을 구축하신 세무사분들을<br>
                        선별하여 모십니다.<br>
                        현업에서 성공하신 분들이 또 다른 도전에도<br>
                        성공할 수 있기 때문입니다.
                    </p>
                    <p>
                        그렇지 않습니다.<br>
                        세무사 역할을 하시면서 당사의 온/오프라인 교육 서비스를 받으시는 중장기적인<br>
                        성장을 지원할 계획입니다.
                    </p>
					<p>
						세무를 포함한 업계 최고의 경영컨설팅 노하우를 전수받고,<br>
						금융전문가로서 성장할 수 있도록 금융 투자상품, M&A 등<br>
						다양한 교육을 받게 되어 고객은 T_앨리를 통해<br>
						One-Stop 기업/개인 컨설팅을 받으실 수 있습니다.
					</p>
                </div>
            </div>
        </div>
    </section>
    <!-- //T_앨리란 -->

	<!-- 문의하기 -->
	<section id="consulting" class="section">
		<div class="inner">
			<div class="img_area anim"></div>
			<div class="title_area anim">
				<u>T_앨리 문의하기</u>
				<p>
					<span>T_앨리와 함께하면 세무를 포함한 업계 최고의 경영컨설팅 노하우를 전수 받고, 금융전문가로서 성장할 수 있도록 금융 투자상품·M&A 등 다양한 교육 및 컨설팅을 받으실 수 있습니다.</span>
				</p>
			</div>
			<div class="render_area anim">
				<div class="render_form"></div>
			</div>
		</div>
	</section>
	<!-- //문의하기 -->

	<!-- 커리어 -->
	<section id="career" class="section">
		<div class="inner">
			<div class="title_area anim">
				<u>
					Career Better, T_앨리
				</u>
			</div>
			<div class="contents_area">
				<div class="cont1">
					<ul>
						<li class="anim">
							<strong>
								협업을 통한 성장
								<img :src="imgPath+'career_ico_01.png'" alt="">
							</strong>
							<em>최고의 영업조직 협업</em>
							<span>업계최고 「이글클럽」</span>
							<span>세종 TSI</span>
							<span>전문가 네트워크</span>
						</li>
						<li class="anim">
							<strong>
								경영 컨설팅(CEO)
								<img :src="imgPath+'career_ico_02.png'" alt="">
							</strong>
							<em>단계별 체계교육</em>
							<span>보험영업기초 Ⅰ, Ⅱ</span>
							<span>법인컨설팅 컨셉</span>
							<span>법인영업 실전사례</span>
						</li>
						<li class="anim">
							<strong>
								금융 전문가(VVIP)
								<img :src="imgPath+'career_ico_03.png'" alt="">
							</strong>
							<em>은행 PB 수준의 개인 컨설팅 역량 교육</em>
							<span>증여ㆍ상속컨설팅</span>
							<span>CEO 개인재무설계</span>
							<span>부동산설계</span>
							<span>VIP고객관리</span>
							<span>M&A 프로세스</span>
						</li>
					</ul>
				</div>
				<div class="cont2">
					<dl>
						<dd class="anim">
							<img :src="imgPath+'career_img_01.png'" alt="">
							<p>
								고객에 대한 서비스, 역량 및<br>
								Career 향상을 통한 성장
							</p>
						</dd>
						<dt class="anim">
							<p>
								One-Stop<br>
								경영/금융 컨설팅<br>
								+<br>
								시장 확대
							</p>
						</dt>
						<dd class="anim">
							<img :src="imgPath+'career_img_02.png'" alt="">
							<p>
								법인컨설팅 전문가<br>
								R&D조직 협업
							</p>
						</dd>
					</dl>
				</div>
			</div>
		</div>
	</section>
	<!-- //커리어 -->

	<!-- 왜 -->
	<section id="why" class="section">
		<div class="inner">
			<div class="title_area anim">
				<u>
					왜 피플라이프<br>
					T_Alliance 인가?
				</u>
				<p>
					<span>
						컨설팅 교육을 통한 법인컨설팅 역량 확보 및<br>
						피플라이프 전문직 설계사와 R&D조직 협업을 통해<br>
						신시장 인프라 확보 및 새로운 소득<br>
						파이프라인을 구축합니다.
					</span>
				</p>
			</div>
			<div class="img_area">
				<ul>
					<li>
						<div class="circle">
							<strong>브랜드</strong>
							<p>
								법인컨설팅의 명가 피플라이프<br>
								한화생명의 역량이 더해진<br>
								대기업형 판매전문회사
							</p>
						</div>
					</li>
					<li>
						<div class="circle">
							<strong>교육 및 인프라</strong>
							<p>
								국내 최고 수준의 교육지원 및<br>
								컨설팅 인프라 지원
							</p>
						</div>
					</li>
					<li>
						<div class="circle">
							<strong>세무 컨설팅</strong>
							<p>
								고액자산가 시장, 상속ㆍ증여 시장<br>
								확대, 보험을 통한 <br>
								종합적인 세무 컨설팅
							</p>
						</div>
					</li>
					<li>
						<div class="circle">
							<strong>M&A 컨설팅</strong>
							<p>
								중소기업 M&A 시장 확대,<br>
								한국 M&A거래소와 전략적<br>
								업무제휴
							</p>
						</div>
					</li>
					<li>
						<div class="circle">
							<strong>시장 확장 기회</strong>
							<p>
								전국 100여개 오피스<br>
								1,800여명의 전문가<br>
								협업을 통한 컨설팅 교류
							</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</section>
	<!-- //왜 -->

	<!-- 라운지(포토갤러리) -->
	<section id="photo" class="section">
		<div class="inner">
			<div class="title_area anim">
				<em>
					전문가를 위한 최적의 환경에서 비즈니스<br>
					성공의 새로운 가능성을 발견하세요.
				</em>
				<u>
					T_앨리 라운지,<br>
					한눈에 살펴보는<br>
					특별한 공간
				</u>
			</div>
			<div class="contents_area">
				<div class="cont1">
					<ul>
						<li>
							<img :src="imgPath+'photo_img_1_01.jpg'" alt="">
						</li>
						<li>
							<img :src="imgPath+'photo_img_1_02.jpg'" alt="">
						</li>
						<li>
							<img :src="imgPath+'photo_img_1_03.jpg'" alt="">
						</li>
						<li>
							<img :src="imgPath+'photo_img_1_04.jpg'" alt="">
						</li>
						<li>
							<img :src="imgPath+'photo_img_1_05.jpg'" alt="">
						</li>
					</ul>
				</div>
				<div class="cont2">
					<ul>
						<li>
							<img :src="imgPath+'photo_img_2_01.jpg'" alt="">
						</li>
						<li>
							<img :src="imgPath+'photo_img_2_02.jpg'" alt="">
						</li>
						<li>
							<img :src="imgPath+'photo_img_2_03.jpg'" alt="">
						</li>
						<li>
							<img :src="imgPath+'photo_img_2_04.jpg'" alt="">
						</li>
						<li>
							<img :src="imgPath+'photo_img_2_05.jpg'" alt="">
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>
	<!-- //라운지(포토갤러리) -->

	<!-- 교육 -->
	<section id="education" class="section">
		<div class="inner">
			<div class="cont1">
				<div class="title_area anim">
					<u>
						T_앨리가<br>
						제공하는 교육
					</u>
					<p>
						<span class="desc active">
							법인영업개요 및 주요 보험상품의 이해
						</span>
						<span class="desc">
							시장 변화에 맞춘 컨셉 및 상품별 스킬교육
						</span>
						<span class="desc">
							실제 판매사례 중심의 컨설팅 역량교육
						</span>
						<span class="desc">
							고객의 상황에 맞춘 증여ㆍ상속 컨설팅
						</span>
						<span class="desc">
							CEO의 기업ㆍ자산 관리 영역별 재무설계
						</span>
						<span class="desc">
							부동산 전문교육을 통한 컨설팅
						</span>
						<span class="desc">
							피플라이프 고객관리지원을 통한 VIP 고객 관리
						</span>
						<span class="desc">
							M&A 전문 컨설팅 교육을 통한 전문가 과정
						</span>
					</p>
					<div class="tab">
						<button type="button" class="active">법인영업의 기초</button>
						<button type="button">법인 컨설팅 컨셉</button>
						<button type="button">법인영업 실전사례</button>
						<button type="button">증여·상속 컨설팅</button>
						<button type="button">CEO 재무설계</button>
						<button type="button">부동산 설계</button>
						<button type="button">VIP 고객관리</button>
						<button type="button">M&A 프로세스</button>
					</div>
				</div>
				<div class="img_area anim">
					<ul>
						<li class="active">
							<img :src="imgPath+'educaton_img_1_01.png'" alt="">
						</li>
						<li>
							<img :src="imgPath+'educaton_img_1_02.png'" alt="">
						</li>
						<li>
							<img :src="imgPath+'educaton_img_1_03.png'" alt="">
						</li>
						<li>
							<img :src="imgPath+'educaton_img_1_04.png'" alt="">
						</li>
						<li>
							<img :src="imgPath+'educaton_img_1_05.png'" alt="">
						</li>
						<li>
							<img :src="imgPath+'educaton_img_1_06.png'" alt="">
						</li>
						<li>
							<img :src="imgPath+'educaton_img_1_07.png'" alt="">
						</li>
						<li>
							<img :src="imgPath+'educaton_img_1_08.png'" alt="">
						</li>
					</ul>
				</div>
			</div>
			<div class="cont2">
				<div class="title_area anim">
					<u>
						교육 지원
					</u>
					<p>
						<span>
							법인 대상 컨설팅 영업을 조직화하여 사업적 비전과<br>
							품격을 한 단계 업그레이드한 원동력은<br>
							바로 체계적인 교육의 힘입니다.
						</span>
					</p>
					<nav>
						<button type="button" class="prev"></button>
						<button type="button" class="next"></button>
					</nav>
				</div>
				<div class="img_area anim">
					<ul>
						<li>
							<img :src="imgPath+'educaton_img_2_01.png'" alt="">
							<dl>
								<dt>신입 과정</dt>
								<dd>세무사 FA를 위한 법인영업개요</dd>
								<dd>주요 보험상품의 이해</dd>
								<dd>법인영업의 핵심적 니즈</dd>
							</dl>
						</li>
						<li>
							<img :src="imgPath+'educaton_img_2_02.png'" alt="">
							<dl>
								<dt>신인 보수 과정</dt>
								<dd>신규 시장이슈와 영업기법에 대한 지속적 교육</dd>
								<dd>상품 교육 및 상품별 활용 Skill</dd>
							</dl>
						</li>
						<li>
							<img :src="imgPath+'educaton_img_2_03.png'" alt="">
							<dl>
								<dt>온라인 교육</dt>
								<dd>피플라이프 법인영업컨셉 동영상 교육</dd>
								<dd>신규 시장 이슈와 영업기법 동영상 교육</dd>
								<dd>연간 세법 개정사항에 맞춘 AP 제안서</dd>
							</dl>
						</li>
						<li>
							<img :src="imgPath+'educaton_img_2_04.png'" alt="">
							<dl>
								<dt>체계화 과정</dt>
								<dd>피플라이프 법인영업 컨설팅 총론</dd>
								<dd>실제 사례를 통한 컨설팅 과정</dd>
								<dd>VVIP고객 관리 역량 교육 과정</dd>
							</dl>
						</li>
						<li>
							<img :src="imgPath+'educaton_img_2_05.png'" alt="">
							<dl>
								<dt>심화 과정</dt>
								<dd>상법/상품/세무/노무/부동산/M&A 컨설팅<br>전문화 과정</dd>
							</dl>
						</li>
					</ul>
					<nav></nav>
				</div>
			</div>
		</div>	
	</section>
	<!-- //교육 -->

	<!-- 혜택 -->
	<section id="favor" class="section">
		<div class="inner">
			<div class="cont1">
				<div class="title_area anim">
					<em>T_앨리 세무사 혜택</em>
					<u>
						세무사 보유고객 대상 컨설팅 제공 서비스
					</u>
				</div>
				<div class="img_area anim">
					<img :src="imgPath+'favor_img_01.png'" alt="">
					<span>피플라이프라는 컨설팅 플랫폼으로 T_앨리[T_Alliance] 세무사에게 다양한 서비스를 제공합니다.</span>
				</div>
			</div>
			<div class="cont2">
				<div class="title_area anim">
					<em>T_앨리 세무사 혜택</em>
					<u>
						법인·VVIP 고객 컨설팅
					</u>
				</div>
				<div class="img_area anim">
					<ul>
						<li>
							<strong>피플라이프,선택의 이유</strong>
							<img :src="imgPath+'favor_img_02.png'" alt="">
						</li>
						<li>
							<strong>T_앨리의 상황에 맞는 다양한 활동 모델 제시</strong>
							<span>전문지식 및 법인컨설팅 역량을 바탕으로 직접 계약하는 T_앨리</span>
							<table>
								<colgroup>
									<col>
									<col>
								</colgroup>
								<thead>
									<tr>
										<th>활동모델</th>
										<th>컨설팅 유형</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th rowspan="4">직접계약</th>
										<td>T_앨리 단독 진행</td>
									</tr>
									<tr>
										<td>T_앨리 상호 간 협업</td>
									</tr>
									<tr>
										<td>피플라이프 전문FA 협업</td>
									</tr>
									<tr>
										<td>세종TSI 세무사 협업</td>
									</tr>
								</tbody>
							</table>
							<span>현업에 바쁜 세무사를 위한 겸업 전문 T_앨리</span>
							<table>
								<colgroup>
									<col>
									<col>
								</colgroup>
								<thead>
									<tr>
										<th>활동모델</th>
										<th>컨설팅 유형</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th rowspan="4">DB소개</th>
										<td>피플라이프 전문FA 협업</td>
									</tr>
									<tr>
										<td>세종TSI 세무사 협업</td>
									</tr>
								</tbody>
							</table>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>
	<!-- //혜택 -->

	<!-- 네트워크 -->
	<section id="network" class="section">
		<div class="inner">
			<div class="title_area anim">
				<em>T_앨리 세무사 혜택</em>
				<u>
					피플라이프 전문가 네트워크 서비스
				</u>
			</div>
			<div class="contents_area anim">
				<div class="tab_wrap">
					<div class="button_wrap">
						<button type="button">세무</button>
						<button type="button">법무</button>
						<button type="button">노무</button>
						<button type="button">부동산</button>
						<button type="button">기업금융</button>
					</div>
					<div class="list_wrap anim">
						<ul>
							<li>
								<p>
									<strong>세무법인 세종TSI</strong>
									<span>
										세종TSI는 피플라이프와 제휴된 업체로 법인 및 고액자산가들에 대한<br>
										경영&자산관리 컨설팅을 제공하고 있는 세무법인 입니다.
									</span>
								</p>
								<div class="box_wrap">
									<div class="box">
										<dl>
											<dt>기업경영 영역</dt>
											<dd><span>이익금 관리</span></dd>
											<dd><span>세무 관련 제도 정비</span></dd>
											<dd><span>핵심인재 관리 및 보상</span></dd>
											<dd><span>모의 세무 진단</span></dd>
											<dd><span>외부감사 전략 수립</span></dd>
											<dd><span>기업진단</span></dd>
											<dd><span>합병 및 분할 전략 수립</span></dd>
											<dd><span>법인에 대한 EXIT 플랜(적정보수, 적정배당정책, 자기주식, 청산 등)</span></dd>
											<dd><span>차명주식 회수</span></dd>
											<dd><span>가지급금, 가수금 정리</span></dd>
											<dd><span>가업승계</span></dd>
											<dd><span>개인사업 법인전환</span></dd>
										</dl>
									</div>
									<div class="box">
										<dl>
											<dt>오너 CEO 자산관리 영역</dt>
											<dd><span>상속증여 플랜</span></dd>
											<dd><span>금융자산 플랜</span></dd>
											<dd><span>부동산 관련 세금</span></dd>
											<dd><span>차명주식 회수</span></dd>
											<dd><span>법인에 대한 EXIT 플랜(적정보수, 적정배당정책, 자기주식, 청산 등)</span></dd>
											<dd><span>가지급금, 가수금 정리</span></dd>
											<dd><span>가업승계</span></dd>
											<dd><span>개인사업 법인전환</span></dd>
										</dl>
									</div>
								</div>
							</li>
							<li>
								<p>
									<strong>가이우스 법률 사무소</strong>
									<span>
										가이우스 법률사무소는 중소기업을 위한 법률상의 특례제도를 구현시키고,<br>
										상법의 회사법편에서 규율하고 있는 회사 경영의 원칙을 중소기업에 정착시키기 위한 자문과 소송에 특화되어 있습니다. 
									</span>
								</p>
								<div class="box_wrap">
									<div class="box">
										<dl>
											<dd><span>법률상 특례제도 구현을 위한 중소기업 육성 및 지원법률 연구</span></dd>
											<dd><span>상법의 회사법편에 따른 적법한 회사경영에 대한 자료</span></dd>
											<dd><span>동업자나 직원의 배신으로 인한 경영 리스크 대비 방안</span></dd>
											<dd><span>기업의 Know How 산업재산권화 지원</span></dd>
											<dd><span>중소기업 경영을 위한 계약서 작성 및 계약서 검토</span></dd>
											<dd><span>중소기업의 골칫거리 차명주식의 실명전환</span></dd>
										</dl>
									</div>
								</div>
							</li>
							<li>
								<p>
									<strong>노무법인 익선, 서현</strong>
									<span>
										좋은 직원을 고용하여 유지하는 것은 중소기업 경쟁력에 있어서 빼 놓을 수 없는 영역입니다.<br>
										간단치 않은 중소기업의 인사와 노무 문제에 대한 풍부한 Solution을 제공해 드립니다.
									</span>
								</p>
								<div class="box_wrap">
									<div class="box">
										<dl>
											<dt>노무 법률 자문</dt>
											<dd><span>근로시간, 임금, 근태, 근로관게 종료, 퇴직금 등 각종 개별적 근로관계에 관한 법률 자문</span></dd>
											<dd><span>산업재해 및 산업안전에 관한 법률문제, 외국인 근로자와 관련된 문제 자문</span></dd>
											<dd><span>노조설립, 단체협상, 쟁의와 개별 요구안에 대한 법률적 평가와 대응 등 노사문제 법률 자문</span></dd>
											<dd><span>연봉제 평가제도, 성과급제 등 인사제도 운영실태에 대한 자문</span></dd>
											<dd><span>파견, 도급, 기간제 근로자와의 법률문제, 국민연금, 고용, 산재, 건강보험업무 자문</span></dd>
											<dd><span>쟁의행위 발생시의 대응 자문</span></dd>
										</dl>
									</div>
									<div class="box">
										<dl>
											<dt>급여아웃소싱 / 4대보험 관리</dt>
											<dd><span>급여체계와 개인별 급여관리, 퇴직자 관리</span></dd>
											<dd><span>산업재해 신청 및 급여청구</span></dd>
											<dd><span>4대보험 취득 및 상실업무, 근로계약서, 취업규칙 정비</span></dd>
											<dd><span>해고, 인사청구, 구제신청 및 대응, 산재 고용보험, 임금체불, 체당금</span></dd>
											<dd><span>노동사건 대리 및 교육서비스</span></dd>
											<dd><span>성희롱 예방교육 등 각종 법정 필수 교육 서비스</span></dd>
										</dl>
									</div>
								</div>
							</li>
							<li>
								<p>
									<strong>부동산 전문</strong>
									<span>
										부동산과 관련된 고객의 수요를 전문가의 시각으로 분석하고<br>
										풍부한 네트워크를 활용하여 최적의 Solution을 제공해 드리겠습니다.
									</span>
								</p>
								<div class="box_wrap">
									<div class="box">
										<dl>
											<dd><span>부동산의 매입, 매각, 개발, 리모델링과 관련된 부동산 최유효 활용</span></dd>
											<dd><span>부동산 매각 관련 적정 Value, 매각 마케팅 계획, 홍보전략 등 자문</span></dd>
											<dd><span>부동산 매매, 임대 관련 중개</span></dd>
											<dd><span>부동산 법인전환의 검토와 실행 서비스</span></dd>
											<dd><span>부동산 감정평가, 법무등기, 개발검토, 분양대행, 부동산 PM</span></dd>
											<dd><span>부동산 매입 관련 적정 Value, 자금계획, 소유구조 등 자문</span></dd>
											<dd><span>특수관게자간 부동산 활용</span></dd>
										</dl>
									</div>
								</div>
							</li>
							<li>
								<p>
									<strong>IPOㆍM&A 전문 삼정KPMG, 한국M&A거래소</strong>
									<span>
										중소ㆍ벤처기업을 위한 기업금융(Corporate Financing) 자문을 전문으로 합니다.
									</span>
								</p>
								<div class="box_wrap">
									<div class="box">
										<dl>
											<dt>IPO 컨설팅</dt>
											<dd><span>코스닥 상장심사 통과 가능성에 대한 분석 및 미비점에 대한 해결책 제시</span></dd>
											<dd><span>사전준비 단계에서 직면하는 이슈에 대한 해결책 및 일정을 포함하여 IPO 로드맵 작성</span></dd>
											<dd><span>주관증권사 선정 후 상장 본 단계에서 발생하는 이슈 및 대응책에 대한 Cross-check</span></dd>
										</dl>
									</div>
									<div class="box">
										<dl>
											<dt>M&A 컨설팅</dt>
											<dd><span>M&A 관련 주체들인 증권회사, 회계법인 PEF, 벤처캐피탈 등 과의 협업을 통해 DEAL 성공률을 극대화</span></dd>
											<dd><span>M&A 관련 협상 자문 및 계약서 등 작성 자문</span></dd>
											<dd><span>M&A 관련 대상에 대한 타당성 평가 및 자문</span></dd>
										</dl>
									</div>
									<div class="box">
										<dl>
											<dt>자금조달 컨설팅</dt>
											<dd><span>투자유치를 위한 제반 여건 충족 여부에 대한 분석과 해결책 제시</span></dd>
											<dd><span>투자조건, 방식(RCPS, CB, BW 등) 및 자료준비 등을 포함한 실행전략 수립</span></dd>
										</dl>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>					
			</div>
		</div>
	</section>
	<!-- //네트워크 -->

	<!-- 정보 -->
	<section id="information" class="section">
		<div class="inner anim">
			<div class="tit">
				<img :src="imgPath+'information_logo.png'" alt="">
			</div>
			<div class="contents">
				<dl>
					<dt>문의</dt>
					<dd>
						<span>피플라이프 마케팅기획팀</span>
						<span>02-2229-4617<!-- <i>·</i> 010-8210-8253--></span>
					</dd>
					<dd>
						<span>채용 담당자</span>
						<span>한강희 책임 (bulludung@peoplelife.co.kr)</span>
					</dd>
					<dd>
						<span>근무장소</span>
						<span>본사 CEO클리닉 T_앨리 라운지(서울 서초구 서초대로 2, 10층)</span>
					</dd>
				</dl>
			</div>
			<div class="caution">
				<ul>
					<li>※ 본 광고는 채용을 위한 홍보용 자료로, 지원내용은 피플라이프 보험대리점의 공지문 및 수수료규정 등 제규정에 의거 적용됩니다.</li>
					<li>※ 본 광고는 보험설계사를 모집하는 것으로 정규 또는 비정규 직원채용과 무관합니다.</li>
				</ul>
				<p>피플-준법-제2025-12-6495호(25.05.23)</p>
			</div>
		</div>
	</section>
	<!-- //정보 -->

	<!-- 입사지원 바로가기 floating -->
    <aside id="banner_apply">        
        <button type="button" class="btn_apply anchor" data-target="#consulting">
            <span class="txt">입사문의</span>
        </button>
        <button type="button" class="btn_kakao">
            <span class="txt"><span class="screen_out">카카오톡</span>공유</span>
        </button>
    </aside>
    <!-- //입사지원 바로가기 floating -->

</main>
<!-- /main -->
</template>



<script>
export default {
    data() {
        return {
            imgPath: '/img/recruit/tally/'
        }
    }
}
</script>



<style scoped lang="scss">
    @import '@/assets/scss/recruit/recruitTally.scss';
</style>